export const pressCoverage = [
  {
    outlet: 'The Hindu',
    logo: '/images/the-hindu-logo.png',
    title:
      "How Bengaluru's pet cafes enable moments of joy, affection and quiet companionship",
    year: '2025',
    href: 'https://www.thehindu.com/life-and-style/how-bengalurus-pet-cafes-enable-moments-of-joy-affection-and-quiet-companionship/article69814569.ece',
  },
  {
    outlet: 'YourStory',
    logo: '/images/yourstory.png',
    title:
      'How this Bangalore startup is building a holistic care ecosystem for pets',
    year: '2019',
    href: 'https://yourstory.com/2019/12/bangalore-startup-petcart-animal-care-health-wellness',
  },
  {
    outlet: 'Deccan Chronicle',
    logo: '/images/deccan-chronicle.png',
    title: 'Pet-friendly options around Bengaluru',
    year: '2019',
    href: 'https://www.deccanchronicle.com/lifestyle/viral-and-trending/031219/pet-friendly-options.html',
  },
  {
    outlet: 'Condé Nast Traveller',
    logo: '/images/conde-nast-traveller.png',
    title: "Bengaluru's new pet resort could be just what your dogter ordered",
    year: '2018',
    href: 'https://www.cntraveller.in/story/bengalurus-new-pet-resort-could-be-just-what-your-dogter-ordered/',
  },
  {
    outlet: 'The New Indian Express',
    logo: '/images/the-new-indian-express.png',
    title: 'Pets and pet parents, resort',
    year: '2018',
    href: 'https://www.newindianexpress.com/bengaluru/2018/Oct/16/pets-and-pet-parents-resort-1886341.html',
  },
  {
    outlet: 'Bangalore Mirror',
    logo: '/images/bangalore-mirror.png',
    title: 'Pets resort to luxury',
    year: '2018',
    href: 'https://bangaloremirror.indiatimes.com/bangalore/others/pets-resort-to-luxury/articleshow/65925351.cms',
  },
];

export const pressLogos = pressCoverage.map(({ logo, outlet, href }) => ({
  src: logo,
  alt: outlet,
  href,
}));
